import CouponTypes from './CouponTypes';

export default CouponTypes;
